import { useState } from 'react';
import { signupApi } from '../../apis';
import { handleApiError } from '../../helpers';
import { SignupDto } from '../../interfaces';
import useResetError from '../useResetError';

const useSignup = () => {
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [email, setEmail] = useState<string>('');
  const { error, setError } = useResetError();

  const onSubmitHandler = async (payload: SignupDto) => {
    setSubmitting(true);
    setError(null);

    try {
      await signupApi(payload);
      setSubmitting(false);
      setSuccess(true);
      setEmail(payload.email);
    } catch (error) {
      console.log(error);
      setSubmitting(false);
      setError(handleApiError(error));
    }
  };

  return { onSubmitHandler, submitting, success, error, email };
};

export default useSignup;
